// Package imports:
import React from "react";
import * as Yup from 'yup';
import { Form, Formik } from "formik";
import Bugsnag from "@bugsnag/js";
// Component imports:
import Button from '../../../ui-elements/Button/Button';
import Input from '../../../ui-elements/Input/Formik/Input';
import Checkbox from "../../../ui-elements/Input/Formik/Checkbox";
import Alert from "../../../ui-elements/Alert/Alert";
// Service imports:
import { GET_KELDAN_API_URL } from '../../../services/config';
import { ErrorMessages } from "../../../services/errorMessages";
// Type imports:
import { IMyKeldaSettingsResponse, MySettingsViewModel } from "../../../types/MyKeldaTypes";

interface IProps {
    model?: MySettingsViewModel,
    setContactResponse: (a: JSX.Element) => void,
}

interface IFormProps {
    values: IFormValues,
}

interface IFormValues {
    customerBonds: boolean,
    customerBondsExplain: string,
    
}

const VedbondForm: React.FC<IProps> = ({
    model,
    setContactResponse
}) => {

    const handleSubmit = async (values: IFormValues) => {
        try {
            setContactResponse(<></>);
            const requestQuery = new URLSearchParams({
                    customerBonds: values.customerBonds.toString(),
                    customerBondsExplain: values.customerBondsExplain,
                    email: model?.myUserInfo?.email ?? ''
            });
            const url = `${GET_KELDAN_API_URL()}/MyKelda/UpdateUserBonds`;
            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
                },
                body: requestQuery
            });
            if (response.ok) {
                if (response.redirected) {
                    window.location.href = response.url;
                } else {
                    const responseBody: IMyKeldaSettingsResponse = await response.json();
                    if (responseBody.saved) {
                        setContactResponse(
                            <Alert
                                closeAlert={() => setContactResponse(<></>)}
                                withCloseIcon
                                type="success"
                                headText='Umsókn send'
                                text="Við munum fara yfir umsókn þína eins fljótt og auðið er."
                            />
                        );
                    }
                    else if (!responseBody.saved){
                        setContactResponse(
                            <Alert
                                closeAlert={() => setContactResponse(<></>)}
                                withCloseIcon
                                type="error"
                                headText={responseBody.info ?? "Umsókn var ekki send"}
                            />
                        );
                    }
                }
            } else {
                setContactResponse(
                    <Alert
                        closeAlert={() => setContactResponse(<></>)}
                        withCloseIcon
                        type="error"
                        headText={ErrorMessages.RequestFailed}
                    />
                );
            }
        } catch (e) {
            if (e instanceof Error) Bugsnag.notify(e);
            setContactResponse(
                <Alert
                    closeAlert={() => setContactResponse(<></>)}
                    withCloseIcon
                    type="error"
                    headText={ErrorMessages.NetworkError}
                />
            );
        }
    }

    const form: React.FC<IFormProps> = ({
        values
    }) => {
        return <Form>
            <div className="checkbox">
                <Checkbox 
                    label="Ég óska eftir aðgangi að veðböndum"
                    name="customerBonds"
                    id="customerBonds"
                    value={values.customerBonds ? 'true' : 'false'}
                />
            </div>
            <Input 
                name="customerBondsExplain"
                id="customerBondsExplain"
                inputType="textArea"
                className="field-input" 
                label="Ástæða fyrir aðgangi"
                value={values.customerBondsExplain}
            />
            <div className="form__actions">
                <Button type="submit" buttonType="primary">Senda umsókn</Button>
            </div>
        </Form>
    }

    return (
        <div className='KCL_Vedbond-form'>
            <Formik
                initialValues={{
                    customerBonds: model?.settingsResponse?.customerBonds ?? true,
                    customerBondsExplain: model?.settingsResponse?.customerBondsExplain ?? '',
                }}
                validationSchema={Yup.object({
                    customerBonds: Yup.boolean()
                        .oneOf([true], 'Vinsamlega hakið við'),
                    customerBondsExplain: Yup.string()
                        .required("Ástæða verður að fylgja"),
                })}
                onSubmit={handleSubmit}
                component={form}
            />
        </div>
    )
}

export default VedbondForm;